import React from "react";
import { FooterStyles } from "styles/style";

export default () => {
  return (
    <FooterStyles.FooterContainer>
      <FooterStyles.FooterContent>
        <FooterStyles.FooterRow>
          <FooterStyles.FooterLinksContainer>
            <FooterStyles.FooterLink href="/disclaimer">Disclaimer</FooterStyles.FooterLink>
            <FooterStyles.FooterLink href="https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/05072024___Privacy_Policy_(Shincheonji)___Final.pdf">Privacy Policy</FooterStyles.FooterLink>
            <FooterStyles.FooterLink href="https://zegleedmcpswaxynxnta.supabase.co/storage/v1/object/public/assets/05072024___Terms_of_Use_(Shincheonji)___Final.pdf">Terms of Use</FooterStyles.FooterLink>
          </FooterStyles.FooterLinksContainer>
          <FooterStyles.FooterCopyrightText>
            &copy; Copyright 2024, Shincheonji. All Rights Reserved.
          </FooterStyles.FooterCopyrightText>
        </FooterStyles.FooterRow>
      </FooterStyles.FooterContent>
    </FooterStyles.FooterContainer>
  );
};
